import { render, staticRenderFns } from "./addFacility.html?vue&type=template&id=0354822f&scoped=true&external"
import script from "./addFacility.vue?vue&type=script&lang=js"
export * from "./addFacility.vue?vue&type=script&lang=js"
import style0 from "./addFacility.css?vue&type=style&index=0&id=0354822f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0354822f",
  null
  
)

export default component.exports